if (jQuery('body').hasClass('page-template-template-videos') ||
    jQuery('body').hasClass('tax-video_category') ||
    jQuery('body').hasClass('single-ndms_videos') &&
    jQuery('body').hasClass('site-id-7')) {
    var currentPage = 1;
    var totalPages = null;

    function goToPage(pageNumber) {
        jQuery("#currentPage").text(currentPage);
        if (currentPage == pageNumber) {
            return;
        }
        jQuery("#previousPageButton").css("background-size", "25px");
        jQuery("#nextPageButton").css("background-size", "25px");

        currentPage = pageNumber;

        jQuery(".recent-video-item").hide();
        if (currentPage <= 1) {
            jQuery("#previousPageButton").css("background-size", "0px");
            jQuery(this).off("click").attr('href', "javascript: void(0);");
        }
        if (currentPage >= totalPages) {
            jQuery("#nextPageButton").css("background-size", "0px");
        }

        params = {
            custom_post: 'videos_nonsponsored',
            page: currentPage,
            limit: postPerPage
        };

        if (typeof catID !== 'undefined') {
            params = {
                custom_post: 'videos_sponsored',
                page: currentPage,
                cat_id: catID,
                limit: postPerPage
            };
        }

        jQuery.getJSON('/', params, function (data) {
            var html = '';
            $.each(data.items, function (key, val) {
                html +=
                    '<div class="recent-video-item" data-page="' + currentPage + '">' +
                    '<a href="' + val.linkURL + '#' + currentPage + '" data-video-id="' + val.id + '" title="Click to watch ' + val.name + '">' +
                    '<span class="vp-video-icon">' +
                    '<i class="fak fa-play-round">&nbsp;</i>' +
                    '</span>' +
                    '<div class="recent-video-image"><img class="lazy-video-thumb" src="' + val.thumbnailURL + '" alt="' + val.name + '" role="presentation"></div>' +
                    '<div class="excerpt-with-image">' +
                    '<h4>' + val.shortName + '</h4>' +
                    '</div>' +
                    '<div class="video-description" style="display:none">' + val.shortDescription + '</div>' +
                    '<div class="video-name" style="display:none">' + val.shortName + '</div>' +
                    '</a>' +
                    '</div>';
            });
            $('.recent-video-container').html(html);
        });

        window.location.hash = currentPage;
    }

    function turnPageAjax(direction, totalPages) {
        console.log('turnPageAjax fired --- ' + direction);
        if (window.location.hash && window.location.hash != "0") {
            currentPage = window.location.hash.replace("#", "");
        }
        jQuery("#previousPageButton").css("background-size", "25px");
        jQuery("#nextPageButton").css("background-size", "25px");
        if (direction == "next" && currentPage != totalPages) {
            currentPage++;
        }

        if (direction == "previous" && window.location.hash != "#1" && window.location.hash) {
            currentPage--;
        }
        jQuery(".recent-video-item").hide();
        if (currentPage <= 1) {
            jQuery("#previousPageButton").css("background-size", "0px");
            jQuery(this).off("click").attr('href', "javascript: void(0);");
        }
        if (currentPage >= totalPages) {
            jQuery("#nextPageButton").css("background-size", "0px");
        }
        jQuery("#currentPage").text(currentPage);

        params = {
            custom_post: 'videos_nonsponsored',
            page: currentPage,
            limit: postPerPage
        };

        if (typeof catID !== 'undefined') {
            params = {
                custom_post: 'videos_sponsored',
                page: currentPage,
                cat_id: catID,
                limit: postPerPage
            };
        }


        jQuery.getJSON('/', params, function (data) {
            var html = '';
            $.each(data.items, function (key, val) {
                html +=
                    '<div class="recent-video-item" data-page="' + currentPage + '">' +
                    '<a href="' + val.linkURL + '#' + currentPage + '" data-video-id="' + val.id + '" title="Click to watch ' + val.name + '">' +
                    '<span class="vp-video-icon">' +
                    '<i class="fak fa-play-round">&nbsp;</i>' +
                    '</span>' +
                    '<div class="recent-video-image"><img class="lazy-video-thumb" src="' + val.thumbnailURL + '" alt="' + val.name + '" role="presentation"></div>' +
                    '<div class="excerpt-with-image">' +
                    '<h4>' + val.shortName + '</h4>' +
                    '</div>' +
                    '<div class="video-description" style="display:none">' + val.longDescription + '</div>' +
                    '<div class="video-name" style="display:none">' + val.shortName + '</div>' +
                    '</a>' +
                    '</div>';
            });
            $('.recent-video-container').html(html);

        });

        window.location.hash = currentPage;

    }
    //this looks to be legacy and we might want rempve it altogether
    function turnPage(direction, totalPages) {
        if (window.location.hash && window.location.hash != "0") {
            currentPage = window.location.hash.replace("#", "");
        }
        jQuery("#previousPageButton").css("background-size", "25px");
        jQuery("#nextPageButton").css("background-size", "25px");
        if (direction == "next" && currentPage != totalPages) {
            currentPage++;
        }

        if (direction == "previous" && window.location.hash != "#1" && window.location.hash) {
            currentPage--;
        }
        setRelatedItems(currentPage);
        window.location.hash = currentPage;
    }

    function setRelatedItems(currentPage, totalPages) {
        jQuery(".recent-video-item").hide();
        if (currentPage <= 1) {
            jQuery("#previousPageButton").css("background-size", "0px");
            jQuery(this).off("click").attr('href', "javascript: void(0);");
        }
        if (currentPage >= totalPages) {
            jQuery("#nextPageButton").css("background-size", "0px");
        }
        jQuery("#currentPage").text(currentPage);
        jQuery('*[data-page="' + currentPage + '"]').show();
    }


    videoResizeInit = function ($) {
        var videoPlayer = $('#amp').length ? $('#amp') : $('.ndms_video_player');
        if (videoPlayer.length > 0) {
            //run once then use resize listener
            videoResize($, videoPlayer);
            $(window).resize(function () {
                videoResize($, videoPlayer);
            });
        }
    };

    videoResize = function ($, videoPlayer) {
        var videoWidth = videoPlayer.css('width');
        if ($('body').length > 0) {
            var newHeight = (parseInt(videoWidth) / 4) * 2.252;
            videoPlayer.css('height', newHeight);
            videoPlayer.css('width', '100%');
        } else {
            videoPlayer.attr('style', '');
        }

    };

    //lazy load video images
    jQuery(function () {
        if (jQuery('.lazy-video-thumb').Lazy) {
            jQuery('.lazy-video-thumb').Lazy({
                visibleOnly: true
            });
        }
    });

    jQuery(document).ready(function () {
        /*
        * set current video
        */

        var currentVideoId = jQuery("#video-wrap").attr("data-video-id");
        jQuery(".vsr-video-list-item").filter('[data-video-id="' + currentVideoId + '"]').addClass('vsr-currently-playing');

        /*
            * pagenation logic
            */

        jQuery("#previousPageButton").css("background-size", "25px");
        jQuery("#nextPageButton").css("background-size", "25px");
        var currentPage = window.location.href.split('#')[1];
        if (currentPage === "" || currentPage === undefined) {
            currentPage = 1;
        }
        goToPage(currentPage);
        //setRelatedItems(currentPage);

        /*
            * If a video is on a page, this listener will resize
            * the video appropriately based on width of the video
            * for tablet and mobile views. It will clear any changes
            * when going into desktop view from a different view
            */

        (function ($) {
            videoResizeInit($);
        })(jQuery);

        /*
            * For lazy loading thumbnails
            */
        jQuery("#nextPageButton").click(function () {
            jQuery('.lazy-video-thumb').lazy({
                bind: "event",
                visibleOnly: true
            });
        });

        /*
            * For analytics tracking
            */
        try {
            jQuery('.vsr-video-list-item').click(function () { clt_linkclick('VideoHub:RightRail'); });
            jQuery('.vsr-video-tab.vsr-first').click(function () { clt_linkclick('VideoHub:AllVideos'); });
            jQuery('.vsr-video-tab.vsr-second').click(function () { clt_linkclick('VideoHub:MostPopular'); });
            jQuery('.vsr-video-tab.vsr-third').click(function () { clt_linkclick('VideoHub:VideoSeries'); });
            jQuery('#search-videos').click(function () { clt_linkclick('VideoHub:SearchButton'); });
            jQuery('.recent-video-item .recent-video-image').click(function () {
                if (jQuery('.sponsored-video-main-col').length == 0) {
                    clt_linkclick('VideoHub:BottomTile:Unsponsored');
                } else {
                    clt_linkclick('VideoHub:BottomTile:Sponsored');
                }
            });
            jQuery('#previousPageButton').click(function () { clt_linkclick('VideoHub:Pagination:Previous'); });
            jQuery('#nextPageButton').click(function () { clt_linkclick('VideoHub:Pagination:Next'); });
            jQuery('.sponsored-video-header .all-videos-link').click(function () { clt_linkclick('VideoHub:AllVideos'); });
        } catch (error) {
            console.log('Error in Video Hub Tracking.');
        }
    });

    (function (window, document, $, undefined) {
        $(document).ready(function () {

            $(function () {
                $('.lazy-rr-thumb').Lazy({
                    visibleOnly: true
                });
            });

            var tab = $('.vsr-video-tab'),
                tabContent = $('.vsr-tab-content'),
                thirdTabMenu = $('.vsr-third-tab-menu'),
                thirdTabContent = $('#vsr-content-third'),
                thirdTabTitle = $('.vsr-video-tab.vsr-third > .vsr-tab-text'),
                thirdTabIcon = $('span.vsr-tab-drop-icon > i'),
                menuItem = $('.vsr-menu-list-item'),
                backButton = $('.vsr-back-button-item'),
                searchButton = $("#search-videos"),
                videoCategory;

            $('#txtSearchVideos').keypress(function (e) {
                var key = e.which;
                if (key == 13)  // the enter key code
                {
                    $('#search-videos').click();
                    return false;
                }
            });
            searchButton.click(function () {

                $.ajax({
                    url: videoSideRail.ajaxurl,
                    type: 'get',
                    data: {
                        action: 'vsr_video_posts',
                        searchQuery: $("#txtSearchVideos").val(),
                        videoCategory: videoCategory
                    },
                    success: function (videos) {
                        thirdTabContent.html(videos);
                        $('.vsr-tab-content').hide();
                        $('.vsr-tab-content.vsr-third').fadeIn('fast');
                        $('.vsr-tab-content.vsr-first .nascar-advertisement').removeAttr("id");
                        $('.vsr-tab-content.vsr-second .nascar-advertisement').removeAttr("id");
                        $('.vsr-tab-content.vsr-third .nascar-advertisement').attr("id", "slot_companion_ad_01");

                        $('.vsr-video-list-item.vsr-ad.no-mobile').hide();

                        $('.lazy-rr-thumb').Lazy({
                            visibleOnly: true
                        });
                    }
                });

            });
            tab.click(function () {

                tab.removeClass('vsr-active');
                $(this).addClass('vsr-active');

                if ($(this).hasClass('vsr-first')) {
                    tabContent.hide(); thirdTabMenu.hide();
                    $('.vsr-tab-content.vsr-first').show();
                    $('.vsr-tab-content.vsr-first .nascar-advertisement').attr("id", "ad_rect_atf_01");
                    $('.vsr-tab-content.vsr-second .nascar-advertisement').removeAttr("id");
                    $('.vsr-tab-content.vsr-third .nascar-advertisement').removeAttr("id");
                    if (!$(this).hasClass("no-ads-refresh")) {
                        AMPTManager.refreshAllAds();
                    }
                }

                if ($(this).hasClass('vsr-second')) {
                    tabContent.hide(); thirdTabMenu.hide();
                    $('.vsr-tab-content.vsr-second').show();
                    $('.vsr-tab-content.vsr-first .nascar-advertisement').removeAttr("id");
                    $('.vsr-tab-content.vsr-second .nascar-advertisement').attr("id", "ad_rect_atf_01");
                    $('.vsr-tab-content.vsr-third .nascar-advertisement').removeAttr("id");
                    if (!$(this).hasClass("no-ads-refresh")) {
                        if ($('.vsr-tab-content.vsr-second .nascar-advertisement').hasClass('ad_rect_atf_01')) {
                            AMPTManager.buildSlotsAjax('https://www.nascar.com/adunit/144/', ['ad_rect_atf_01']);
                            $('.vsr-tab-content.vsr-second .nascar-advertisement').removeClass("ad_rect_atf_01");
                        }
                        AMPTManager.refreshAllAds();
                    }
                }

                if ($(this).hasClass('vsr-third')) {
                    thirdTabMenu.toggle();
                    thirdTabIcon.toggleClass('fa-caret-down fa-caret-up');
                }

                $(function () {
                    $('.lazy-rr-thumb').Lazy({
                        bind: "event",
                        visibleOnly: true
                    });
                });
            });

            backButton.click(function () {
                if ($(this).hasClass('vsr-back-button-item')) {
                    thirdTabMenu.hide();
                    thirdTabIcon
                        .removeClass('fa-caret-up')
                        .addClass('fa-caret-down');
                }
            });

            menuItem.click(function () {
                thirdTabTitle.html($(this).html());
                thirdTabMenu.fadeOut('fast');

                //Check right rail menu button for long name
                if ($(".vsr-video-tab.vsr-third.vsr-active").height() > 48) {
                    $(".vsr-third-tab-menu").addClass("long-name");
                } else {
                    $(".vsr-third-tab-menu").removeClass("long-name");
                }

                videoCategory = $(this).data('slug');
                location.href = '/videos/franchise/' + videoCategory;
            });


        });
    })(window, document, jQuery);
}